import { useState } from 'react';
import { Button } from '@/components/ui/button';

export function Politics() {
  const [count, setCount] = useState(0);

  return (
    <div className="flex flex-col h-[calc(100vh-8rem)]">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold mb-1">Politics</h1>
          <p className="text-muted-foreground">Insights and management for political data.</p>
        </div>
        <Button
          onClick={() => setCount((c) => c + 1)}
          className="bg-primary text-primary-foreground hover:bg-primary/90"
        >
          Clicked {count} times
        </Button>
      </div>

      <div className="rounded-lg border border-border p-6 bg-card/50">
        <p className="text-sm text-muted-foreground">
          This page uses the same header spacing and button styling as the Order Management page.
          Replace this content with your politics-related components.
        </p>
      </div>
    </div>
  );
}

export default Politics;